import i18n from './../../../shared/i18n';
import {store} from './../../../plugins/vuex/index'
import BaseModel from "../../../core/components/input-widget/BaseModel";
import {EMAIL_REGEX, getPhoneRuleObj} from "@/plugins/vee-validate";
import CustomerFormAddressModel from "./CustomerFormAddressModel";
import i18nHelper from "@/core/services/i18n.service";

export default class CustomerForm extends BaseModel {
  uuid = null;
  first_name = '';
  middle_name = '';
  last_name = '';
  company_name = '';
  personal_id = '';
  is_company = false;
  email = '';
  phone = '';
  status = 'active';
  title = '';
  email2 = '';
  phone1 = '';
  phone2 = '';
  preferred_language_code = null;
  acquisition_source = '';
  acquisition_source_text = '';
  tax_status_uuid = '';
  enable_estimate_request = store.state.global.currentBranch ? store.state.global.currentBranch.enable_estimate_request : false;
  sms_optin = false;
  tags = store.state.global.tagsInputFormat == 'plain' ? '' : [];
  commissions = [];
  billingAddresses = [];
  shippingAddresses = [];
  addresses = [];
  bank_accounts = [];
  birth_date = null;
  defaultShippingAddress = new CustomerFormAddressModel({
    type: 'shipping',
    is_primary: true,
    country_code: store.state.global.currentBranch ? store.state.global.currentBranch.country_code : ''
  });
  defaultBillingAddress = new CustomerFormAddressModel({
    type: 'billing',
    is_primary: true,
    country_code: store.state.global.currentBranch ? store.state.global.currentBranch.country_code : ''
  })
  account_managers_uuid = null;
  account_managers = {}

  show_shipping_address = false;
  show_billing_address = false;
  no_email = false;
  email_opt_out = false;
  initials = null;
  gender = null;
  deceased = false;
  intermediary_type = null;
  type = null;
  vendor_lead_status = null;
  buyer_lead_status = null;
  correspondence = null;
  block_requesting_condition_reports = false;
  client_tier = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});

    if (this.addresses && this.addresses.length > 0) {
      const address = this.addresses.find(a => a.type === "shipping" && a.is_primary === true);
      if (address) {
        address.email = address.email ? address.email : this.email;
        if (!address.phone && this.phone) {
          address.phone = this.phone.split(',')[0]
        }
        address.isAlreadyAddedToAddresses = true;
        this.defaultShippingAddress = new CustomerFormAddressModel(address);
      }
      const billingAddress = this.addresses.find(a => a.type === "billing" && a.is_primary === true);
      if (billingAddress) {
        billingAddress.email = billingAddress.email ? billingAddress.email : this.email;
        if (!billingAddress.phone && this.phone) {
          billingAddress.phone = this.phone.split(',')[0]
        }
        billingAddress.isAlreadyAddedToAddresses = true;
        this.defaultBillingAddress = new CustomerFormAddressModel(billingAddress);
      }
    }
    this.preferred_language_code = this.preferred_language_code || i18nHelper.getMasterLanguage().key;
    if (this.account_managers && this.account_managers.length > 0) {
      this.account_managers_uuid = this.account_managers[0].uuid
    } else {
      this.account_managers_uuid = null;
    }
  }

  rules = {
    first_name: 'required',
    last_name: 'required',
    status: 'required',
    preferred_language_code: 'required',
    email2: {
      regex: EMAIL_REGEX,
      max: 73
    },
    phone1: getPhoneRuleObj(),
    phone2: getPhoneRuleObj()
  };

  attributeHints = {
    tags: i18n.t('Type tagname and hit enter')
  };

  attributeLabels = {
    first_name: i18n.t('First Name'),
    middle_name: i18n.t('Middle Name'),
    company_name: i18n.t('Company Name'),
    last_name: i18n.t('Last Name'),
    is_company: i18n.t('Is Company'),
    title: i18n.t('Title'),
    status: i18n.t('Status'),
    personal_id: i18n.t('Personal ID'),
    phone: i18n.t('Phone 1'),
    phone1: i18n.t('Phone 1'),
    phone2: i18n.t('Phone 2'),
    email: i18n.t('Email 1'),
    email2: i18n.t('Email 2'),
    no_email: i18n.t('No Email'),
    tags: i18n.t('Tags'),
    acquisition_source: i18n.t('Acquisition Source'),
    acquisition_source_text: i18n.t('Acquisition Source Text'),
    no: i18n.t('No'),
    enable_estimate_request: i18n.t('Estimate Request'),
    email_opt_out: i18n.t('Email Opt Out'),
    sms_optin: i18n.t('Text Message Notification Optin'),
    preferred_language_code: i18n.t('Preferred Language'),
    account_managers_uuid: i18n.t('Account Manager'),
    birth_date: i18n.t('Date of Birth'),
    initials: i18n.t('Initials'),
    gender: i18n.t('Gender'),
    deceased: i18n.t('Deceased'),
    intermediary_type: i18n.t('Intermediary Type'),
    type: i18n.t('Type'),
    vendor_lead_status: i18n.t('Vendor Lead Status'),
    buyer_lead_status: i18n.t('Buyer Lead Status'),
    correspondence: i18n.t('Correspondence'),
    block_requesting_condition_reports: i18n.t('Block Customer from Requesting Condition Reports'),
    client_tier: i18n.t('Client Tier'),
  }

  getDataForCustomerFormSubmission() {
    for (const address of [this.defaultShippingAddress, this.defaultBillingAddress]) {
      if (address.address_1) {
        if (!address.isAlreadyAddedToAddresses) {
          address.isAlreadyAddedToAddresses = true;
          this.addresses.push(address);
        } else {
          const index = this.addresses.findIndex(a => a.isAlreadyAddedToAddresses === true && a.type === address.type)
          this.addresses[index] = address;
        }
      } else {
        if (address.isAlreadyAddedToAddresses) {
          const index = this.addresses.findIndex(a => a.isAlreadyAddedToAddresses === true && a.type === address.type)
          this.addresses.splice(index, 1)
          address.isAlreadyAddedToAddresses = false; // we removed this address from `addresses` array
        }
      }
    }
    const params = Object.assign({}, {
      uuid: this.uuid,
      first_name: this.first_name,
      middle_name: this.middle_name,
      last_name: this.last_name,
      company_name: this.company_name,
      personal_id: this.personal_id,
      is_company: this.is_company,
      enable_estimate_request: this.enable_estimate_request,
      sms_optin: this.sms_optin,
      status: this.status,
      title: this.title,
      email: this.email,
      email2: this.email2,
      phone1: this.phone1,
      phone2: this.phone2,
      tags: this.tags,
      acquisition_source: this.acquisition_source,
      acquisition_source_text: this.acquisition_source_text,
      addresses: this.addresses,
      preferred_language_code: this.preferred_language_code,
      account_managers_uuid: this.account_managers_uuid ? [this.account_managers_uuid] : [],
      birth_date: this.birth_date ? this.birth_date : null,
      no_email: this.no_email,
      gender: this.gender,
      email_opt_out: this.email_opt_out,
      type: this.type,
      intermediary_type: this.intermediary_type,
      deceased: this.deceased,
      initials: this.initials,
      vendor_lead_status: this.vendor_lead_status,
      buyer_lead_status: this.buyer_lead_status,
      correspondence: this.correspondence,
      block_requesting_condition_reports: this.block_requesting_condition_reports,
      client_tier: this.client_tier,
    });

    params.phone = [params.phone1, params.phone2].filter(data => data !== '' && data).join();

    if (params.acquisition_source === 'Other (free text)') {
      params.acquisition_source = params.acquisition_source_text;
    }

    if (!store.state.global.tagsInputFormat || store.state.global.tagsInputFormat == 'dropdown') {
      params.tags = params.tags && params.tags.length ? params.tags.join(',') : '';
    }

    return params;
  }
}
